import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { typography, fontWeights } from '../../../styles/typography';
import { MediaQueries } from '../../../styles/Grid';

export const titleCss = css(typography.effra48, {
  color: colorsPalette.grey,
  fontWeight: fontWeights.medium,
  lineHeight: 1.2,
  position: 'relative',
  margin: '24px 0',
});

export const descriptionCss = css(typography.effra18, {
  lineHeight: 1.66,
  color: colorsPalette.grey80,
  margin: '24px 0',
});

export const marginCss = css({
  margin: '71px 0 160px',

  [MediaQueries.lgAndUp]: {
    margin: '135px auto 224px',
  },
});

export const containerCss = css({
  padding: '0 24px',
  display: 'none',

  [MediaQueries.mdAndUp]: {
    display: 'flex',
  },

  [MediaQueries.lgAndUp]: {
    maxWidth: 1138,
  },
});

export const contentCss = css({
  width: '50%',
  padding: '0 16px',

  [MediaQueries.lgAndUp]: {
    order: 2,
  },
});

export const imagesColumnCss = css({
  alignItems: 'flex-end',
  display: 'flex',
  justifyContent: 'center',
  padding: '0 16px',
  width: '50%',
  ['.form-img']: {
    width: 232,
    height: 232,
  },
  [MediaQueries.mdAndUp]: {
    alignItems: 'flex-start',
  },
  [MediaQueries.lgAndUp]: {
    order: 1,
    alignItems: 'center',
    ['.form-img']: {
      width: 440,
      height: 440,
    },
  },
  [MediaQueries.xl]: {
    justifyContent: 'end',
  },
});

export const formContainerCss = css({
  display: 'block',
  marginTop: 32,
  maxWidth: 404,
});

export const selectsContainerCss = css({
  marginBottom: 20,
  width: '100%',
});

export const selectCss = css({
  marginBottom: 32,
});
